/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBan: {
  name: 'ban';
  data: string;
} = {
  name: 'ban',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.094 5.68A8 8 0 0 1 18.32 16.905L7.094 5.68ZM5.68 7.094A8 8 0 0 0 16.905 18.32L5.68 7.094ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Z" fill="currentColor"/></svg>`,
};
